import { useState, useEffect, useCallback, type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

export default function PageTransition({ children }: { children: ReactNode }) {
  const location = useLocation();
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [enterKey, setEnterKey] = useState(0);

  const trigger = useCallback(() => {
    setIsTransitioning(true);
    setEnterKey((k) => k + 1);
    const t = setTimeout(() => setIsTransitioning(false), 500);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    trigger();
  }, [location.pathname, trigger]);

  return (
    <div className="relative min-h-screen">
      {/* Terminal scan overlay */}
      <div className={`page-transition-overlay ${isTransitioning ? 'active' : ''}`}>
        <div className="transition-glitch-flash"></div>
        <div className="transition-scan-beam beam-1"></div>
        <div className="transition-scan-beam beam-2"></div>
        <div className="transition-scan-beam beam-3"></div>
        <div className="transition-data-rain"></div>
      </div>

      {/* Page content with enter animation */}
      <div key={enterKey} className="page-transition-enter">
        {children}
      </div>
    </div>
  );
}
